import { Spin } from "antd";

export default () => (
  <div style={{ paddingTop: 200, textAlign: 'center' }}>
     <Spin />
  </div>
);
